import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Box, Heading, Image, Text, Link } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled(Box).attrs(function (_ref) {
  var theme = _ref.theme;
  return {
    $py: theme.header.highlighted.verticalPadding,
    $px: theme.header.highlighted.horizontalPadding,
    $styles: {
      borderRadius: theme.header.highlighted.radius,
      backgroundColor: theme.header.highlighted.background
    }
  };
}).withConfig({
  displayName: "Highlighted__Container",
  componentId: "sc-1b2quhy-0"
})([""]);
var ItemContainer = styled(Box).attrs(function (_ref2) {
  var theme = _ref2.theme;
  return {
    $styles: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  };
}).withConfig({
  displayName: "Highlighted__ItemContainer",
  componentId: "sc-1b2quhy-1"
})([""]);
var ItemLink = styled(Link).withConfig({
  displayName: "Highlighted__ItemLink",
  componentId: "sc-1b2quhy-2"
})(["display:block;&:focus{", "}"], function (props) {
  return props.theme.normalizeStyles(props.theme.focus.outlines.withOffset);
});
var Headline = styled(Heading).attrs(function (_ref3) {
  var theme = _ref3.theme;
  return {
    as: theme.header.highlighted.headline.as,
    $mb: theme.header.highlighted.margins.afterHeadline,
    $variant: theme.header.highlighted.headline.variant
  };
}).withConfig({
  displayName: "Highlighted__Headline",
  componentId: "sc-1b2quhy-3"
})([""]);
var ViewAllLink = styled(Link).attrs(function (_ref4) {
  var theme = _ref4.theme;
  return {
    $variant: theme.header.highlighted.viewAllLink.variant,
    $color: theme.header.highlighted.viewAllLink.color,
    $size: theme.header.highlighted.viewAllLink.size,
    withArrow: theme.header.highlighted.viewAllLink.withArrow
  };
}).withConfig({
  displayName: "Highlighted__ViewAllLink",
  componentId: "sc-1b2quhy-4"
})([""]);
var ItemTitle = styled(Text).attrs(function (_ref5) {
  var theme = _ref5.theme;
  return {
    $mb: theme.header.highlighted.margins.afterTitle,
    $variant: theme.header.highlighted.itemTitle.variant
  };
}).withConfig({
  displayName: "Highlighted__ItemTitle",
  componentId: "sc-1b2quhy-5"
})([""]);
var ItemDescription = styled(Text).attrs(function (_ref6) {
  var theme = _ref6.theme;
  return {
    $variant: theme.header.highlighted.itemDescription.variant,
    $styles: {
      color: theme.header.highlighted.itemDescription.color
    }
  };
}).withConfig({
  displayName: "Highlighted__ItemDescription",
  componentId: "sc-1b2quhy-6"
})([""]);

var Item = function Item(props) {
  var image = props.image,
      title = props.title,
      description = props.description,
      path = props.path;
  var theme = useTheme();
  return /*#__PURE__*/_jsx(ItemLink, {
    href: path,
    $mb: theme.header.highlighted.margins.afterItem,
    children: /*#__PURE__*/_jsxs(ItemContainer, {
      children: [/*#__PURE__*/_jsx(Box, {
        $mr: theme.header.highlighted.margins.afterImage,
        $styles: {
          width: theme.header.highlighted.imageWidth
        },
        children: image && /*#__PURE__*/_jsx(Image, _objectSpread({
          "aria-hidden": true
        }, image))
      }), /*#__PURE__*/_jsxs(Box, {
        $styles: {
          width: theme.header.highlighted.textWidth
        },
        children: [/*#__PURE__*/_jsx(ItemTitle, {
          children: title
        }), /*#__PURE__*/_jsx(ItemDescription, {
          children: description
        })]
      })]
    })
  });
};

var Highlighted = function Highlighted(props) {
  var title = props.title,
      items = props.items,
      showAllLink = props.showAllLink;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Headline, {
      children: title
    }), /*#__PURE__*/_jsx("ul", {
      children: items.map(function (item) {
        return /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(Item, _objectSpread({}, item))
        }, item.title);
      })
    }), /*#__PURE__*/_jsx(ViewAllLink, {
      href: showAllLink.path,
      children: showAllLink.title
    })]
  });
};

export default Object.assign(Highlighted, {
  Item: Item
});